import { render } from "./MalaTags.vue?vue&type=template&id=68e3320f&scoped=true"
import script from "./MalaTags.vue?vue&type=script&lang=js"
export * from "./MalaTags.vue?vue&type=script&lang=js"

import "./MalaTags.vue?vue&type=style&index=0&id=68e3320f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e3320f"]])

export default __exports__